
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.125 7.604a6.634 6.634 0 01-.713 3.009 6.73 6.73 0 01-6.016 3.72 6.634 6.634 0 01-3.009-.712L.876 15.125l1.504-4.512a6.634 6.634 0 01-.712-3.009 6.73 6.73 0 013.72-6.016A6.634 6.634 0 018.396.875h.396a6.713 6.713 0 016.333 6.333v.396z"}})])
          )
        }
      }
    